<template>
  <div class="popup_layer popup_radio">
    <div class="close_layer" @click="closePopup()"></div>
    <div class="container">
      <h3>{{ commonSelect.title }}</h3>
      <ul>
        <li v-for="(list, idx) in commonSelect.list" :key="idx" class="radio_common">
          <input :id="`list${list}${idx}`" v-model="selectValue" type="radio" :value="list" @change="sendValue()">
          <label :for="`list${list}${idx}`">{{ list }}</label>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      selectValue: '',
      radioPopBool: false
    }
  },
  computed: {
    ...mapState(['commonSelect'])
  },
  mounted () {
    this.selectValue = this.commonSelect.value
  },
  destroyed () {
    this.$store.state.commonSelect.list = []
  },
  methods: {
    closePopup () {
      document.body.classList.remove('overhidden')
      this.$store.state.commonSelect.visible = false
    },
    sendValue () {
      this.$emit('sendVal', this.selectValue)
      this.closePopup()
    }
  }
}
</script>
